import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import Settings from 'Event/template/Townhall/ImageWaterfall/ImageWaterfallConfig/Settings'
import Styling from 'Event/template/Townhall/ImageWaterfall/ImageWaterfallConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import {Townhall, useTownhallUpdate} from 'Event/template/Townhall'

export default function TownhallImageWaterfallConfig(
  props: ComponentConfigProps,
) {
  const {showing: isVisible, onClose} = props

  const {control, register, handleSubmit, formState} = useForm()

  const updateTemplate = useTownhallUpdate()

  const submit = (data: Townhall['imageWaterfall']) => {
    updateTemplate({
      imageWaterfall: data,
    })

    onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Image Waterfall"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
